import React, { Fragment, useEffect, useRef, useState } from "react";
import { Col, Form, Row } from "react-bootstrap";
import * as apicall from "../../components/Apicall";
import { MdOutlineDeleteOutline } from "react-icons/md";
import { Dropdown } from "primereact/dropdown";

function EachAddOffering({
  isUpdate = false,
  allServices,
  partners,
  data,
  updateData,
  updateOfferingData,
  index,
  removeOffering,
}) {
  const [selectedService, setSelectedService] = useState("");
  const [service, setService] = useState({});
  const [serviceType, setServiceType] = useState([]);
  const lastRequestId = useRef(0);
  const [allType, setAllType] = useState([]);
  const [allOffering, setAllOffering] = useState([]);

  useEffect(() => {
    getserviceTypes(data?.service_id);
  }, []);
  console.log("service--", service);
  const getserviceTypes = async (s1) => {
    try {
      let currentId = ++lastRequestId.current;

      const response = await apicall.get(
        `get_ezp_service_type?service_id=${s1}`
      );
      if (currentId !== lastRequestId.current) return;

      let ans = response?.data?.map((item) => ({
        service_type_id: item.id,
        service_type_name: item.name,
      }));
      ans.unshift({ service_type_id: 0, service_type_name: "Custom" });
      setServiceType(ans);
    } catch (e) {
      console.log("err---", e);
    }
  };

  const getAlloffering = async (data) => {
    try {
      let service_type_id = Number(data?.split("-")[0]);

      if (service_type_id === 0) {
        const response = await apicall.get(`getAllType/${service?.id}`);
        setAllType(response?.data?.map((ele) => ele?.name));
      } else {
        const response = await apicall.get(`getAlloffering/${service_type_id}`);
        setAllOffering(response?.data?.map((ele) => ele?.name));
      }
    } catch (e) {
      console.log("err---", e);
    }
  };

  const updateField = (field, value) => {
    try {
      let copyData = { ...data };

      if (field === "time_required") {
        let d1 = copyData[field];
        if (value === "+") {
          d1 += 30;
        } else {
          d1 -= 30;
        }

        if (d1 < 30) d1 = 30;
        if (d1 > 480) d1 = 480;
        copyData[field] = d1;
      } else {
        copyData[field] = value;
      }

      if (copyData?.["error"]?.[`${field}_error`]) {
        copyData["error"][`${field}_error`] = "";
        delete copyData["error"][`${field}_error`];
      }

      if (allType?.includes(value) && field === "custom_type_name") {
        copyData["error"][`${field}_error`] =
          "Already this sub category is used";
      }

      if (allOffering?.includes(value) && field === "service_offering_name") {
        copyData["error"][`${field}_error`] = "Already this type is used";
      }

      console.log("copyData---", copyData);

      if (!isUpdate) {
        updateData({ index, copyData });
      } else {
        if (!index) index = 1;
        updateOfferingData(copyData);
      }
    } catch (e) {
      console.log("errr---", e);
    }
  };

  const keyValueChanged = (k1, v1) => {
    try {
      setSelectedService(v1);
      let d1 = k1.split("-");
      let d2 = v1.split("-");

      let copyData = { ...data };
      copyData[d1[0]] = Number(d2[0]) || 0;
      copyData[d1[1]] = d2[1] || "";

      if (d1[0] === "service_id") {
        let s1 = allServices?.find((s) => s.id === Number(d2[0]));
        setService(s1 || {});

        if (!copyData["error"]) copyData["error"] = {};
        copyData["error"] = {};

        copyData["service_type_id"] = 0;
        copyData["service_type_name"] = "";
        copyData["service_offering_id"] = 0;
        copyData["service_offering_name"] = "";
        copyData["partner_id"] = 0;
        copyData["partner_name"] = "";
        copyData["amount"] = 0;
        copyData["time_required"] = 30;
        copyData["buffer"] = null;
        copyData["custom_type_name"] = "";

        if ("custom_type_name" in copyData) {
          delete copyData["custom_type_name"];
        }

        if (s1?.service_type) {
          getserviceTypes(Number(d2[0]));
          copyData["service_type"] = true;
        } else {
          copyData["service_type"] = false;
        }
      }

      if (d1[0] === "service_type_id" && d1[1] === "Custom") {
        if ("custom_type_name" in copyData) {
        } else {
          copyData["custom_type_name"] = "";
        }
      } else if (d1[0] === "service_type_id") {
        if ("custom_type_name" in copyData) {
          delete copyData["custom_type_name"];
        }
      }

      if (copyData?.["error"]?.[`${d1[1]}_error`]) {
        copyData["error"][`${d1[1]}_error`] = "";
        delete copyData["error"][`${d1[1]}_error`];
      }

      updateData({ index, copyData });
    } catch (e) {
      console.log("err---".e);
    }
  };

  const convertToHoursMins = (data) => {
    try {
      let h = Math.floor(data / 60);
      let m = data % 60;
      let ans = ``;
      if (h) ans += ` ${h} hr`;
      if (m) ans += ` ${m} mins`;
      return ans;
    } catch (e) {
      console.log("err----", e);
    }
  };

  return (
    <div className="border-bottom pb-2 mt-2">
      <Row className="position-relative">
        {!isUpdate ? (
          <Col md={3} className="mb-2">
            <Form.Group>
              <Form.Label>Service Category</Form.Label>
              <Dropdown
                name="service"
                value={
                  data?.service_id
                    ? `${data.service_id}-${data.service_name}`
                    : ""
                }
                options={allServices?.map((service) => ({
                  label: service.name,
                  value: `${service.id}-${service.name}`,
                }))}
                appendTo="self"
                placeholder="Select Service"
                onChange={(e) => {
                  keyValueChanged("service_id-service_name", e.value);
                }}
                className={`w-100 ${
                  data?.error?.service_name_error ? "is-invalid" : ""
                }`}
                style={{
                  height: "40px",
                  backgroundColor: "white",
                  border: data?.error?.service_name_error
                    ? "1px solid #dc3545"
                    : "1px solid #E9ECEF",
                }}
              />
            </Form.Group>
          </Col>
        ) : (
          <Col md={3} className="mb-2">
            <Form.Group>
              <Form.Label>Service Category</Form.Label>
              <Form.Control
                type="text"
                name="servie_name"
                placeholder="Enter Service Name..."
                value={data?.service_name || ""}
                onChange={(e) => updateField("service_name", e.target.value)}
                className="form-input "
                style={{
                  borderColor: data?.["error"]?.["service_name_error"]
                    ? "#dc3545"
                    : "#E9ECEF",
                }}
              />
              {/* {data?.["error"]?.["service_name_error"] && (
                <div className="invalid-feedback d-block">
                  {data?.["error"]?.["service_name_error"]}
                </div>
              )} */}
              {/* {data?.error?.service_name_error && (
  <div className="invalid-feedback d-block">
    {data.error.service_name_error}
  </div>
)} */}
              <div className="error-space">
                {data?.error?.service_name_error && (
                  <div className="invalid-feedback d-block">
                    {data.error.service_name_error}
                  </div>
                )}
              </div>
            </Form.Group>
          </Col>
        )}

        {(data?.service_name || selectedService || isUpdate) && (
          <Fragment>
            {!isUpdate ? (
              <>
                {service?.service_type || data?.service_type_id ? (
                  <Col md={3} className="mb-2">
                    <Form.Group>
                      <Form.Label>Sub Category</Form.Label>

                      <Dropdown
                        value={
                          data?.service_type_id || data?.service_type_name
                            ? `${data?.service_type_id}-${data?.service_type_name}`
                            : ""
                        }
                        options={serviceType?.map((type) => ({
                          label: type.service_type_name,
                          value: `${type.service_type_id}-${type.service_type_name}`,
                        }))}
                        placeholder="Select Type"
                        onChange={(e) => {
                          keyValueChanged(
                            "service_type_id-service_type_name",
                            e.value
                          );
                          getAlloffering(e.value);
                        }}
                        className={`w-100${
                          data?.["error"]?.["service_type_name_error"]
                            ? "is-invalid"
                            : ""
                        }`}
                        style={{
                          borderColor: data?.["error"]?.[
                            "service_type_name_error"
                          ]
                            ? "#dc3545"
                            : "#E9ECEF",
                        }}
                        appendTo="self"
                      />
                      {/* {data?.error?.service_type_name_error && (
  <div className="invalid-feedback d-block">
    {data.error.service_type_name_error}
  </div>
)} */}
                      <div className="error-space">
                        {data?.error?.service_type_name_error && (
                          <div className="invalid-feedback d-block">
                            {data.error.service_type_name_error}
                          </div>
                        )}
                      </div>
                    </Form.Group>
                  </Col>
                ) : (
                  <></>
                )}

                {data?.service_type_name === "Custom" && (
                  <Col md={3} className="mb-2">
                    <Form.Group>
                      <Form.Label>Custom Type Name</Form.Label>
                      <Form.Control
                        type="text"
                        name="TypeName"
                        placeholder="Custom Type Name..."
                        value={data?.custom_type_name || ""}
                        onChange={(e) =>
                          updateField("custom_type_name", e.target.value)
                        }
                        className="form-input "
                        style={{
                          borderColor: data?.["error"]?.[
                            "custom_type_name_error"
                          ]
                            ? "#dc3545"
                            : "#E9ECEF",
                        }}
                      />
                      {/* {data?.["error"]?.["custom_type_name_error"] && (
                        <div className="invalid-feedback d-block">
                          {data?.["error"]?.["custom_type_name_error"]}
                        </div>
                      )} */}
                      {/* {data?.error?.custom_type_name_error && (
  <div className="invalid-feedback d-block">
    {data.error.custom_type_name_error}
  </div>
)} */}
                      <div className="error-space">
                        {data?.error?.custom_type_name_error && (
                          <div className="invalid-feedback d-block">
                            {data.error.custom_type_name_error}
                          </div>
                        )}
                      </div>
                    </Form.Group>
                  </Col>
                )}
              </>
            ) : (
              <>
                {data?.service_type ? (
                  <Col md={3} className="mb-2">
                    <Form.Group>
                      <Form.Label>Sub Category</Form.Label>
                      <Form.Control
                        type="text"
                        name="servie_type_name"
                        placeholder="Enter Type Name..."
                        value={data?.service_type_name || ""}
                        onChange={(e) =>
                          updateField("service_type_name", e.target.value)
                        }
                        className="form-input "
                        style={{
                          borderColor: data?.["error"]?.[
                            "service_type_name_error"
                          ]
                            ? "#dc3545"
                            : "#E9ECEF",
                        }}
                      />
                      {/* {data?.["error"]?.["service_type_name_error"] && (
                        <div className="invalid-feedback d-block">
                          {data?.["error"]?.["service_type_name_error"]}
                        </div>
                      )} */}
                      <div className="error-space">
                        {data?.error?.service_type_name_error && (
                          <div className="invalid-feedback d-block">
                            {data.error.service_type_name_error}
                          </div>
                        )}
                      </div>
                      {/* {data?.error?.service_type_name_error && (
  <div className="invalid-feedback d-block">
    {data.error.service_type_name_error}
  </div>
)} */}
                    </Form.Group>
                  </Col>
                ) : (
                  <></>
                )}
              </>
            )}

            <Col md={3} className="mb-2">
              <Form.Group>
                <Form.Label>Service Type</Form.Label>
                <Form.Control
                  type="text"
                  name="Offering"
                  placeholder="Enter Offering Name..."
                  value={data?.service_offering_name || ""}
                  onChange={(e) =>
                    updateField("service_offering_name", e.target.value)
                  }
                  className="form-input "
                  style={{
                    borderColor: data?.["error"]?.[
                      "service_offering_name_error"
                    ]
                      ? "#dc3545"
                      : "#E9ECEF",
                  }}
                />

                {/* {data?.["error"]?.["service_offering_name_error"] && (
                  <div className="invalid-feedback d-block">
                    {data?.["error"]?.["service_offering_name_error"]}
                  </div>
                )} */}

                <div className="error-space">
                  {data?.error?.service_offering_name_error && (
                    <div className="invalid-feedback d-block">
                      {data.error.service_offering_name_error}
                    </div>
                  )}
                </div>
              </Form.Group>
            </Col>

            {isUpdate ? (
              <Col md={3} className="mb-2">
                <Form.Group>
                  <Form.Label>Profile</Form.Label>
                  <Dropdown
                    value={data?.partner_id || ""}
                    options={partners?.map((type) => ({
                      label: type.partner_name,
                      value: type.id,
                    }))}
                    placeholder="Select Profile"
                    onChange={(e) => updateField("partner_id", e.value)}
                    className={`w-100 ${
                      data?.["error"]?.["partner_name_error"]
                        ? "is-invalid"
                        : ""
                    }`}
                    style={{
                      borderColor: data?.["error"]?.["partner_name_error"]
                        ? "#dc3545"
                        : "#E9ECEF",
                    }}
                    appendTo="self"
                  />
                </Form.Group>
              </Col>
            ) : (
              <Col md={3} className="mb-2">
                <Form.Group>
                  <Form.Label>Profile</Form.Label>
                  <Dropdown
                    value={
                      data?.partner_id && data?.partner_name
                        ? `${data.partner_id}-${data.partner_name}`
                        : ""
                    }
                    options={partners?.map((type) => ({
                      label: type.partner_name,
                      value: `${type.id}-${type.partner_name}`,
                    }))}
                    placeholder="Select Profile"
                    onChange={(e) =>
                      keyValueChanged("partner_id-partner_name", e.value)
                    }
                    className={`w-100 ${
                      data?.error?.partner_name_error ? "is-invalid" : ""
                    }`}
                    style={{
                      borderColor: data?.error?.partner_name_error
                        ? "#dc3545"
                        : "#E9ECEF",
                    }}
                    appendTo="self"
                  />
                  <div className="error-space">
                    {data?.error?.partner_name_error && (
                      <div className="invalid-feedback d-block">
                        {data.error.partner_name_error}
                      </div>
                    )}
                  </div>
                </Form.Group>
              </Col>
            )}

            <Col md={3} className="mb-2">
              <Form.Group>
                <Form.Label>Price</Form.Label>
                <Form.Control
                  type="text"
                  name="price"
                  placeholder="Enter Price..."
                  value={data?.amount || ""}
                  onChange={(e) =>
                    updateField("amount", Number(e.target.value))
                  }
                  className={`form-input `}
                  style={{
                    borderColor: data?.["error"]?.["amount_error"]
                      ? "#dc3545"
                      : "#E9ECEF",
                  }}
                />

                {data?.["error"]?.["amount_error"] && (
                  <div className="invalid-feedback d-block">
                    {data?.["error"]?.["amount_error"]}
                  </div>
                )}
                {/* {data?.error?.amount_error && (
  <div className="invalid-feedback d-block">
    {data.error.amount_error}
  </div>
)} */}
              </Form.Group>
            </Col>
            <Col md={3} className="mb-2">
              <Form.Group>
                <Form.Label>Time Required</Form.Label>

                <div className="d-flex justify-content-between mx-4 align-items-center gap-2">
                  <div
                    className="plusMinus"
                    onClick={() => updateField("time_required", "-")}
                  >
                    -
                  </div>
                  <div> {convertToHoursMins(data.time_required) || 0}</div>
                  <div
                    className="plusMinus"
                    onClick={() => updateField("time_required", "+")}
                  >
                    +
                  </div>
                </div>
              </Form.Group>
            </Col>
            <Col md={3} className="mb-2">
              <Form.Group>
                <Form.Label>Buffer</Form.Label>
                <Dropdown
                  value={
                    data?.buffer !== undefined && data?.buffer !== null
                      ? `${data.buffer}m`
                      : ""
                  }
                  options={["0m", "30m", "60m", "90m"].map((t) => ({
                    label: t,
                    value: t,
                  }))}
                  placeholder="Select Buffer time"
                  onChange={(e) =>
                    updateField("buffer", Number(e.value.replace("m", "")))
                  }
                  className={`w-100${
                    data?.error?.buffer_error ? "is-invalid" : ""
                  }`}
                  style={{
                    borderColor: data?.error?.buffer_error
                      ? "#dc3545"
                      : "#E9ECEF",
                  }}
                  appendTo="self"
                />
                <div className="error-space">
                  {data?.error?.buffer_error && (
                    <div className="invalid-feedback d-block">
                      {data.error.buffer_error}
                    </div>
                  )}
                </div>
              </Form.Group>
            </Col>

            {!isUpdate && (
              <Col md={3} className="d-flex  mb-2 align-items-center">
                <Form.Group>
                  <div
                    onClick={() => removeOffering(index)}
                    className="btn-danger rounded p-0 px-1 cursor-pointer position-absolute top-0 end-0"
                  >
                    <MdOutlineDeleteOutline />
                  </div>
                </Form.Group>
              </Col>
            )}
          </Fragment>
        )}
      </Row>
    </div>
  );
}

export default EachAddOffering;
